import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { IRootConfig, SuperHttpClientModule } from '@paella-front/ngx-super-http-client';
import { environment } from 'src/environments';

import { OauthHttpInterceptor } from './core/helpers/oauth.http-interceptor';

const config: IRootConfig = {
  domains: {
    oauth: {
      url: environment.server.oauth,
      headers: { Authorization: environment.PUBLIC_JWT },
    },
    platform: {
      url: environment.server.platform,
      headers: { Authorization: environment.PUBLIC_JWT },
      isDefault: true,
    },
    qr: {
      url: environment.server.qr,
      headers: { Authorization: environment.PUBLIC_JWT },
    },
    cp: {
      url: environment.server.cp,
      headers: { Authorization: environment.PUBLIC_JWT },
    },
  },
};

@NgModule({
  exports: [SuperHttpClientModule],
  imports: [SuperHttpClientModule.forRoot(config)],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: OauthHttpInterceptor, multi: true },
  ],
})
class PaellaSuperHttpClientModule {}

export { PaellaSuperHttpClientModule };
